import React from "react";
import styled from "styled-components";


export default styled.div`
    width: 100%;
    flex: 0 0 auto;
    border-bottom: 1px solid lightgray;
    padding-bottom: 20px;

    @media(min-width: 768px){
        width:68px;
        border-bottom: none;
        padding-bottom: 0;
        min-height: 94px;
        margin-top: 2px;
    }

    @media(min-width: 1400px){
        width: 133px;
    }
`;
